export default __webpack_public_path__ + "static/media/HP_wb-07.5d7cb1cc.jpg";